import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {GameInfoModuleConfig} from "./game-info-module.config";
import {GameInfoModuleStore} from "./game-info-module.store";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {GameInfoModuleHandlers} from "./handlers/game-info-module.handlers";

export class GameInfoModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, GameInfoModuleConfig, GameInfoModuleStore, GameInfoModuleHandlers];
}
